import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Modal from 'react-modal';
import { AvailableForPurchaseProduct } from '../../../../../interfaces/merchants/resources/books';
import MerchantProductPurchaseModal from '../../../products/purchases/modal';
import css from './BookingPurchaseProduct.module.scss';
import { UserContextConsumer } from '../../../../../contexts/UserContext';

interface Props {
  merchantId: string;
  product: AvailableForPurchaseProduct;
  onClose: () => void;
}

Modal.setAppElement('#__next');

const BookingPurchaseProduct = ({
  merchantId,
  product,
  intl,
  onClose,
}: Props & InjectedIntlProps) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const handleModalClose = () => {
    onClose();
    setIsOpen(false);
  };

  const handleModalOpen = () => {
    setIsOpen(true);
  };

  const contentLabel = `product-${product.public_id}`;

  return (
    <div key={product.public_id} className={css.BookingPurchaseProduct}>
      <a className={css.BookingPurchaseProduct__Link} onClick={handleModalOpen}>
        {`${product.name} （${intl.formatMessage(
          { id: 'common.price' },
          { price: intl.formatNumber(product.price) },
        )})`}
      </a>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleModalClose}
        className={css.SubscriptionModal}
        overlayClassName={css.SubscriptionModal__Overlay}
        contentLabel={contentLabel}
      >
        <div className={css.SubscriptionModal__Content}>
          <UserContextConsumer>
            {context => (
              <MerchantProductPurchaseModal
                session={context.session}
                publicId={merchantId}
                productId={product.public_id}
              />
            )}
          </UserContextConsumer>
        </div>
        <svg
          className={css.SubscriptionModal__CloseIcon}
          onClick={handleModalClose}
        >
          <use xlinkHref="#close" />
        </svg>
      </Modal>
    </div>
  );
};

export default injectIntl(BookingPurchaseProduct);
